import { render } from "./templatedesigne.vue?vue&type=template&id=38ac706a"
import script from "./templatedesigne.vue?vue&type=script&lang=js"
export * from "./templatedesigne.vue?vue&type=script&lang=js"

import "./templatedesigne.vue?vue&type=style&index=0&id=38ac706a&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekalifront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__